import { createFileRoute } from "@tanstack/react-router";
import { OrgGroupsPage } from "@/features/admin/org-groups-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/grupy-organizacyjne")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: OrgGroupsPage,
});
